export default (theme) => ({
  selectContainer: {
    maxWidth: 256,
    minWidth: 256,
  },
});
